module.exports = __webpack_public_path__ + "static/img/ss1.36b832e1.png";